import { IInstitutionAttribute } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { InstitutionAttributeWorkItem } from 'src/app/business/institution/institution-attribute-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class InstitutionAttributeCommandHandler extends EntityCommandHandler<IInstitutionAttribute> {
  protected workItem: IWorkItem<IInstitutionAttribute>;

  constructor(institutionAttributeWorkItem: InstitutionAttributeWorkItem) {
    super();
    this.workItem = institutionAttributeWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'InstitutionAttributeDto';
  }
}
